export enum ProductTableType {
  SIMPLE = 'simple-search',
  ADVANCE = 'advance-search',
  PARSING_CAR = 'parsing-car',
}